module.exports = __webpack_public_path__ + "img/30_27.6323727d.png";